export function formatMachineDisplayName(name: string, displayName?: string): string {
  const custom = displayName?.trim()
  if (custom) return custom
  if (!name) return "Unknown machine"
  const trimmed = name.trim()
  const match = trimmed.match(/^(.+?)(\d{5,})$/)
  if (match && match[1] && match[2]) {
    const prefix = match[1].replace(/[-_]+$/, "")
    return prefix
  }
  return trimmed
}

export function formatMachineAvatar(name: string, displayName?: string): string {
  if (!name && !displayName) return "OM"
  const formatted = formatMachineDisplayName(name, displayName)
  const letters = formatted.replace(/[^a-zA-Z]/g, "")
  if (letters.length >= 2) return letters.slice(0, 2).toUpperCase()
  if (name.length >= 2) return name.slice(0, 2).toUpperCase()
  return "OM"
}
